<template>
  <div>
    <div class="columns">
      <div class="column is-2">
        <b-icon icon="bed"></b-icon>
      </div>
      <div class="column is-10">
        <h4 class="is-size-6 has-text-weight-bold"> {{ journey.hotelName}}</h4>
        <h4 class="is-size-7"> {{ journey.chainName }}</h4>
<!--         {{journey}}-->
        <p class="is-size-6 has-text-grey-light">  {{ journey.startDate | formatDate }} - {{ journey.endDate | formatDate }} </p>
        <div class="is-size-7">{{ journey.description.bedMessage}}</div>
        <OutOfPolicyTag v-if="journey.travelPolicy" class="" :travelPolicy="journey.travelPolicy"></OutOfPolicyTag>
        <a v-if="!display_full" @click="display_full = !display_full" class="gant-text is-size-7">Show details</a>
        <a v-else @click="display_full = !display_full" class="is-size-7">Hide details</a><br />
      </div>
    </div>
    <div v-if="display_full" class="columns is-vcentered mt-2">
      <div class="column is-5">
        <img width="200" :src="journey.image">
      </div>
      <div class="column is-vcentered">
        <div>
          <span class="is-size-6 has-text-grey-light"> {{ journey.hotelName}} </span><br />
          <div class="is-size-7 has-text-grey-light capitalize" style="font-size: 12px;">{{ journey.textDescription}}... </div>
          <span style="font-size: 12px; padding-top: 5px; margin-right: -5px;"> <a @click="goToMaps(journey.position.lat , journey.position.lng)"> {{ journey.address }}</a> </span> <b-icon icon="map-marker"></b-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import OutOfPolicyTag from '../Tags/OutOfPolicyTag.vue';
  import GMap from '../GMap/GMap.vue';

  export default {
    name: 'SmallHotelItinerary',
    components: {
        OutOfPolicyTag,
      },
    props: {
        journey: Object,
      },
    data: function () {
      return {
        display_full: false,
      }
    },
    methods: {
      goToMaps(lat, long) {
        // console.log('tried')
        var details = {
            parent: this,
            component: GMap,
            props: {
              "lat": lat,
              "long": long,
              "width": '700',
              "height": '600',
              'carOrHotel': 'bed'
          },
            hasModalCard: true,
            trapFocus: true,
            width: 700
        }
          this.$buefy.modal.open(details)
        }
    },
  }
</script>

<style scoped>
</style>
